import React from 'react';
import { EmailForm } from '../components/EmailForm';
import { ContactForm } from '../components/ContactForm';
import { MobileForm } from '../components/MobileForm';
import { ReviewFormDetails } from '../components/ReviewFormDetails';
import { STEPS } from './constants';
import { BirthDate } from '../components/BirthDate'
import { CountryCode } from '../components/CountryCode'
import { PassWord } from '../components/PassWord';
import { PrivacyConsent } from '../components/PrivacyConsent';
import { ErrorStep } from '../components/ErrorStep';
import { CreateAccount } from '../components/CreateAccount';
import { SuccessStep } from   '../components/SuccessStep' 

export const getCurrentForm = (step) => {
  switch (step) {
    case STEPS.EMAIL:
      return <EmailForm />;
    case STEPS.CONTACT:
      return <ContactForm />;
    case STEPS.MOBILE:
      return <MobileForm />;
    case STEPS.BIRTHDATE:
      return <BirthDate />;
    case STEPS.COUNTRYCODE:
      return <CountryCode />; 
    case STEPS.PASSWORD:
      return <PassWord />;
    case STEPS.PRIVACYCONSENT:
      return <PrivacyConsent />;
    case STEPS.CREATEACCOUNT:
      return <CreateAccount />;
    case STEPS.REVIEW:
      return <ReviewFormDetails />;
    case STEPS.SUCCESS:
      return <SuccessStep />;  
      // case STEPS.CODE:
      // return Toast.error("Invalid Code");
    case STEPS.ERROR:
      return <ErrorStep /> ;
    default:
      return <h1>Invalid Step. Please refresh the page</h1>;
  }
};
